import { setDefaultOptions } from 'date-fns';
import { enGB, fr, it } from 'date-fns/locale';
import dayjs from 'dayjs';
import i18n from 'i18next';
import LanguageDetector, {
  type DetectorOptions,
} from 'i18next-browser-languagedetector';
import ChainedBackend from 'i18next-chained-backend';
import Backend from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import moment from 'moment';
import { initReactI18next } from 'react-i18next';

import { AUTONE_LANGUAGE_STORAGE_KEY } from '../constants';

const locales = {
  fr,
  it,
  en: enGB,
};

import 'moment/dist/locale/fr';
import 'moment/dist/locale/it';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import { addFormatters } from './formatters';

const detectionOptions: DetectorOptions = {
  order: ['localStorage', 'navigator'],
  caches: ['localStorage'],
  lookupLocalStorage: AUTONE_LANGUAGE_STORAGE_KEY,
};

i18n
  .use(ChainedBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem(AUTONE_LANGUAGE_STORAGE_KEY) || 'en',
    detection: detectionOptions,
    // @ts-ignore
    debug: import.meta.env.MODE === 'development',
    fallbackLng: 'en',
    ns: ['common'],
    returnEmptyString: false,
    interpolation: { escapeValue: false },
    backend: {
      backends: [
        Backend,
        resourcesToBackend((language: string, namespace: string) => {
          if (language === 'en-US') {
            return import(`../../locales/en/${namespace}.json`);
          }
          // @ts-ignore
          return import(`../../locales/${language}/${namespace}.json`);
        }),
      ],
    },
  });

addFormatters(i18n);
i18n.on('languageChanged', (lng) => {
  switch (lng) {
    case 'fr':
    case 'it':
    case 'en': {
      moment.locale(lng);
      dayjs.locale(lng);
      setDefaultOptions({ locale: locales[lng] });
      return;
    }
    default: {
      moment.locale(lng);
      dayjs.locale(lng);
      setDefaultOptions({
        locale: locales[(lng || 'en') as keyof typeof locales],
      });
      return;
    }
  }
});

export default i18n;
